export default __webpack_public_path__ + "static/media/cert-E-commerce-hkgcsmeaa.dddd627c.jpg";